import React from "react";
import { Form, Input } from "antd";
import { LockOutlined } from "@ant-design/icons";

const FormPasswordConfirm = (props) => {
  // -------------------------- VAR --------------------------
  const { disabled } = props;
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- FUNCTION --------------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN --------------------------
  return (
    <Form.Item
      name="confirm"
      dependencies={["password"]}
      hasFeedback
      rules={[
        {
          required: true,
          message: "Làm ơn nhập lại mật khẩu!",
        },
        {
          whitespace: true,
          message: "Mật khẩu không chứa khoảng trắng",
        },
        {
          min: 8,
          message: "Độ dài tối thiểu của mật khẩu là 8 ký tự",
        },
        ({ getFieldValue }) => ({
          validator(_, value) {
            if (!value || getFieldValue("password") === value) {
              return Promise.resolve();
            }
            return Promise.reject(new Error("Hai mật khẩu không trùng khớp"));
          },
        }),
      ]}
    >
      <Input.Password
        showCount
        prefix={<LockOutlined className="form-item-icon" />}
        placeholder="Nhập lại mật khẩu"
        disabled={disabled}
        className="min-h-[40px] bg-transparent"
      />
    </Form.Item>
  );
};

export default FormPasswordConfirm;
